import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SharePanel from '../components/SharePanel';
import LocationList from '../components/LocationList';
import TopHeaderMenu from '../components/TopHeaderMenu';
import MsgNetLoading from '../components/MsgNetLoading';
import CONFIG from '../config';

class LocationListScreenClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = { locations: [], isLoading: true, evento: null, showSharePanel: false };
  }

  toggleSharePanel() {
    this.setState(state => ({ showSharePanel: !state.showSharePanel }));
  }

  componentDidMount() {
    const eventoId = parseInt(this.props.params.eventoId, 10);
    fetch(`${CONFIG.API_URL}/api/1.0/live/evento/${eventoId}/`)
      .then(r => r.json())
      .then(data => this.setState({ evento: data.evento, locations: data.locations || [], isLoading: false }))
      .catch(err => { console.error('live-evento error:', err); this.setState({ isLoading: false }); });
  }

  render() {
    const { evento, locations, isLoading, showSharePanel } = this.state;
    return (
      <div className="min-h-screen bg-gray-900">
        <TopHeaderMenu
          competicion={evento}
          evento={{ nombre: 'Atletas por localización' }}
          onClickBack={() => this.props.navigate(-1)}
          onClickShare={this.toggleSharePanel.bind(this)}
        />
        {isLoading ? (
          <div className="flex justify-center"><MsgNetLoading /></div>
        ) : (
          <div className="pt-4">
            {showSharePanel && (
              <SharePanel
                close={this.toggleSharePanel.bind(this)}
                url={`/${evento?.id}/locations/`}
                title={`Atletas por localización en ${evento?.nombre}`}
              />
            )}
            {evento && evento.visible ? (
              locations.length > 0 ? (
                <LocationList locations={locations} evento={evento} />
              ) : (
                <div className="text-center py-16">
                  <h2 className="text-lg font-montserrat text-slate-400">No hay localizaciones disponibles</h2>
                </div>
              )
            ) : (
              <div className="text-center py-16">
                <h2 className="text-lg font-montserrat text-slate-400">No se ha podido encontrar el evento</h2>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

function LocationListScreen() {
  const navigate = useNavigate();
  const params = useParams();
  return <LocationListScreenClass navigate={navigate} params={params} />;
}

export default LocationListScreen;
